import { useEffect, useState } from 'react';
import { Layout } from '../components/Layout';
import axios from 'axios';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { logger } from '../utils/logger';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Static style objects defined once to avoid re-creating on every render.
const AXIS_STYLE_MONO = { fontFamily: 'IBM Plex Mono' };
const AXIS_STYLE_MONO_SMALL = { fontFamily: 'IBM Plex Mono', fontSize: '12px' };
const TOOLTIP_STYLE = { border: '1px solid #E4E4E7', fontFamily: 'IBM Plex Sans' };
const TOOLTIP_LABEL_STYLE = { fontWeight: 'bold' };

export const StatisticsPage = () => {
  const [monthlyData, setMonthlyData] = useState([]);
  const [sparePartsData, setSparePartsData] = useState([]);

  useEffect(() => {
    fetchStatistics();
  }, []);

  const fetchStatistics = async () => {
    try {
      const [monthlyResponse, sparePartsResponse] = await Promise.all([
        axios.get(`${API}/statistics/monthly`),
        axios.get(`${API}/statistics/spare-parts`)
      ]);
      setMonthlyData(monthlyResponse.data.slice(-12));
      setSparePartsData(sparePartsResponse.data);
    } catch (error) {
      logger.error('Error fetching statistics:', error);
    }
  };

  return (
    <Layout>
      <div className="space-y-8">
        <div>
          <h1 className="text-4xl sm:text-5xl font-black tracking-tighter">Estadísticas</h1>
          <p className="text-base text-muted-foreground mt-2">Análisis de órdenes y refacciones</p>
        </div>

        <div className="p-8 border border-border bg-background">
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight mb-6">Órdenes por Mes (Últimos 12 meses)</h2>
          {monthlyData.length > 0 ? (
            <ResponsiveContainer width="100%" height={400}>
              <BarChart data={monthlyData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E4E4E7" />
                <XAxis dataKey="month" stroke="#09090B" style={AXIS_STYLE_MONO} />
                <YAxis stroke="#09090B" style={AXIS_STYLE_MONO} />
                <Tooltip
                  contentStyle={TOOLTIP_STYLE}
                  labelStyle={TOOLTIP_LABEL_STYLE}
                />
                <Bar dataKey="count" fill="#E11D48" name="Órdenes" />
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <p className="text-center text-muted-foreground py-12">No hay datos disponibles</p>
          )}
        </div>

        <div className="p-8 border border-border bg-background">
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight mb-6">Refacciones Más Requeridas</h2>
          {sparePartsData.length > 0 ? (
            <ResponsiveContainer width="100%" height={400}>
              <BarChart data={sparePartsData} layout="vertical">
                <CartesianGrid strokeDasharray="3 3" stroke="#E4E4E7" />
                <XAxis type="number" stroke="#09090B" style={AXIS_STYLE_MONO} />
                <YAxis
                  dataKey="name"
                  type="category"
                  stroke="#09090B"
                  style={AXIS_STYLE_MONO_SMALL}
                  width={120}
                />
                <Tooltip
                  contentStyle={TOOLTIP_STYLE}
                  labelStyle={TOOLTIP_LABEL_STYLE}
                />
                <Bar dataKey="count" fill="#09090B" name="Cantidad" />
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <p className="text-center text-muted-foreground py-12">No hay datos disponibles</p>
          )}
        </div>
      </div>
    </Layout>
  );
};
